module.exports = __webpack_public_path__ + "static/img/Golf-National.4919792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Golf-National.jpg
// module id = zTCG
// module chunks = 0